import React from "react";

const BorderBottom = () => {
    return(<hr className="h-px my-4 bg-gray-200 border-0 dark:bg-gray-700"/>);
}

export default BorderBottom;